module.exports = __webpack_public_path__ + "img/sysset.16e16470.png";